import { useTranslation } from 'react-i18next';
import { AddGuestBody } from '@components/modals/add-holder-modal/src/add-holder-modal.type';
import { BaseAdmission } from '@domain/admission';
import { useGenericMutation } from '@hooks/use-generic-mutation';
import { useToast } from '@hooks/use-toast/use-toast';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

export interface AddGuestResponse extends BaseAdmission {
  token: string;
  legacyId: number;
}

const addGuest = async ({ formValue }: { formValue: AddGuestBody }) => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/add-guest`;

  return request({ url, method: RequestMethod.POST, body: formValue });
};

export const useAddGuest = ({ hideToast }: { hideToast?: boolean } = {}) => {
  const toast = useToast();
  const { t } = useTranslation();
  return useGenericMutation<AddGuestResponse, RequestError, { formValue: AddGuestBody }>(
    ['add-guest'],
    async ({ formValue }: { formValue: AddGuestBody }) => addGuest({ formValue }),
    {
      onSuccess: hideToast
        ? () => {}
        : () => {
            toast.push({
              title: t('passes:addHolderSuccessNotificationTitle'),
              text: '',
              type: 'success',
            });
          },
      // TODO: Show only custom error on demand https://xceeddev.atlassian.net/browse/XCEED-5272
      // onError: () => {
      //   toast.push({
      //     title: t('passes:addHolderErrorNotificationTitle'),
      //     text: '',
      //     type: 'error',
      //     disableTimeOut: true,
      //   });
      // },
    }
  );
};
